import * as React from "react";
import { LinkOutlined } from "@ant-design/icons";
import { EntityInput, PropsEntityInput } from "./EntityInput";

type PropsEntityLinkEdit = PropsEntityInput;

export const EntityLinkEdit: React.FC<PropsEntityLinkEdit> = (props) => (
  <EntityInput {...props} addonBefore={<LinkOutlined />} />
);
